var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33, _g4, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g5, _path48, _path49, _path50, _path51, _g6, _path52, _path53, _path54, _path55, _path56, _g7, _path57, _path58, _path59, _path60, _path61, _g8, _path62, _path63, _path64, _path65, _path66, _g9, _path67, _path68, _path69, _path70, _path71, _g10, _path72, _path73, _path74, _path75, _path76, _g11, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4000,
    height: 3000,
    viewBox: "0 0 4000 3000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.448 442.631H3283.15C3371.56 442.631 3443.89 512.732 3443.89 598.423V2341.38H580.71V598.423C580.71 512.732 653.038 442.631 741.448 442.631ZM2012.3 511.07C1998.43 511.07 1987.19 521.962 1987.19 535.4C1987.19 548.838 1998.43 559.729 2012.3 559.729C2026.17 559.729 2037.42 548.838 2037.42 535.4C2037.42 521.962 2026.17 511.07 2012.3 511.07ZM739.604 651.981H3285V2190.45H739.604V651.981Z",
    fill: "#373F47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3285 651.982H739.603V2190.45H3285V651.982Z",
    fill: "#C0C0C0",
    stroke: "black",
    strokeWidth: 0.66624,
    strokeMiterlimit: 2.61313
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.002 2371.52H3685V2497.09C3685 2530.24 3657.88 2557.37 3624.72 2557.37H375.281C342.126 2557.37 315.002 2530.24 315.002 2497.09V2371.52Z",
    fill: "#373F47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2700.92 1127.58C2699.8 1126.76 2697.14 1126.47 2695.9 1126.23C2690.75 1125.21 2685.45 1124.77 2680.2 1124.77C2664.02 1124.8 2647.58 1126.39 2631.67 1129.14C2621.57 1130.88 2609.36 1136.75 2599.31 1133.56C2581.8 1128.01 2564.11 1128.28 2547.5 1136.21C2532.32 1143.46 2520.79 1157.24 2514.06 1172.12C2513.05 1174.37 2508.93 1182.64 2507.76 1188.22C2507.26 1189.36 2506.79 1190.51 2506.35 1191.67C2505.13 1194.98 2504.03 1198.34 2503.01 1201.71C2502.57 1203.15 2501.48 1206.33 2502.78 1206.94C2500.7 1210.78 2498.85 1214.74 2497.32 1218.83C2492.85 1230.71 2487.96 1243.75 2486.39 1256.35C2485.81 1261.01 2485.79 1265.7 2486.33 1270.38C2486.6 1272.69 2486.48 1277.33 2488.05 1279.09C2491.37 1282.82 2493.08 1277.6 2492.7 1275.11C2489.84 1256.17 2495.37 1238.39 2501.92 1220.58C2506.15 1209.07 2513.11 1198.54 2520.9 1189C2527.21 1181.28 2533.98 1175.2 2542.62 1170.08C2553.2 1163.82 2564.5 1158.76 2575.7 1153.69C2583.06 1150.35 2590.44 1147.1 2598.01 1144.22C2599.69 1143.58 2602.34 1141.94 2604.21 1141.93C2608.16 1141.92 2613.75 1144.83 2617.57 1145.91C2630.11 1149.48 2642.81 1154.04 2655.78 1155.86C2664.09 1157.03 2671.88 1155.72 2679.66 1152.95C2680.45 1152.67 2681.78 1151.94 2683.41 1150.9C2689.19 1148.68 2694.65 1145.88 2699.4 1141.85C2702.14 1139.53 2704.63 1136.53 2706.9 1133.78C2707.57 1132.96 2707.87 1132.02 2707.88 1131.12C2708.4 1130.85 2708.74 1130.54 2708.82 1130.17C2709.38 1127.47 2704.22 1127.42 2700.92 1127.58Z",
    fill: "#89C5CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2679.05 1202.8C2671.85 1201.24 2663.9 1201.36 2656.57 1201.49C2617.23 1202.02 2578.61 1220.48 2553.47 1249.97C2532.06 1275.08 2526.18 1306.29 2521.95 1337.85C2521.53 1340.98 2521.35 1344.1 2521.12 1347.24C2521.07 1347.91 2520.99 1348.51 2520.91 1349.08C2519.25 1350.55 2518.38 1352.27 2519.36 1354.15C2515.7 1362.1 2512.6 1370.25 2509.94 1378.65C2502.11 1403.38 2494.15 1428.58 2499.06 1454.58C2500.2 1440.27 2502.61 1425.64 2505.49 1411.56C2505.66 1410.75 2505.84 1409.95 2506.02 1409.15C2506.05 1409.07 2506.06 1408.99 2506.08 1408.9C2507.1 1404.59 2508.43 1400.41 2510.04 1396.3C2510.06 1396.25 2510.07 1396.21 2510.09 1396.16C2510.3 1395.62 2510.53 1395.08 2510.75 1394.54C2511.21 1393.43 2511.69 1392.31 2512.19 1391.21C2512.36 1390.83 2512.53 1390.45 2512.68 1390.06C2515.03 1384.36 2516.02 1377.94 2518.13 1372.03C2518.63 1370.69 2519.16 1369.36 2519.71 1368.02C2519.74 1367.95 2519.77 1367.87 2519.81 1367.79C2521.29 1364.21 2522.94 1360.68 2524.68 1357.18C2525.63 1356.48 2526.13 1354.73 2526.95 1353.14C2527.12 1352.83 2528.43 1350.74 2528.83 1349.54C2529.85 1347.57 2530.87 1345.61 2531.91 1343.65C2531.87 1343.66 2531.84 1343.67 2531.81 1343.68C2532.84 1341.8 2533.88 1339.92 2534.91 1338.05C2535.13 1337.64 2535.36 1337.23 2535.59 1336.82C2535.96 1336.17 2536.33 1335.51 2536.7 1334.86C2540.14 1328.75 2543.8 1322.76 2547.59 1316.84C2548.94 1314.73 2552.18 1311.71 2552.8 1309.33C2552.82 1309.25 2552.83 1309.17 2552.84 1309.08C2561.07 1297.62 2570.55 1287.05 2581.92 1278.67C2580.54 1280.15 2577.62 1285.14 2576.85 1286.13C2574.49 1289.16 2571.92 1291.98 2569.35 1294.83C2564.74 1299.94 2560.24 1305.21 2556.23 1310.79C2548.92 1320.99 2542.61 1331.72 2536.64 1342.67C2536.59 1342.73 2536.52 1342.79 2536.47 1342.86C2533.47 1346.52 2531.59 1352.06 2529.43 1356.25C2537.97 1352.33 2547.41 1349.77 2556.18 1346.29C2564.92 1342.82 2573.43 1338.96 2581.64 1334.42C2592.55 1328.38 2603.87 1321.57 2614.18 1313.86C2626 1306.6 2635.93 1296.6 2644.69 1286.11C2655.06 1273.69 2664.56 1261.17 2670.44 1246.09C2673.33 1238.69 2675.6 1230.97 2676.95 1223.15C2677 1222.81 2677.08 1222.44 2677.16 1222.06C2678.54 1219.36 2679.77 1216.6 2680.81 1213.78C2682.45 1209.3 2686.32 1204.37 2679.05 1202.8Z",
    fill: "#56919C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2744.37 1451.67C2740.17 1442.15 2731.29 1434.8 2722.57 1429.34C2688.5 1408.05 2648.55 1400.71 2609.09 1402.31C2587.46 1403.18 2565.67 1407.89 2545.12 1414.13C2533.26 1417.73 2521.75 1422.45 2511.43 1429.25C2504.47 1433.84 2498.26 1439.28 2492.57 1445.34C2485.64 1452.72 2478.94 1460.49 2472.99 1468.68C2470.65 1471.91 2457.51 1488.58 2462.92 1492.38C2462.61 1492.8 2462.34 1493.22 2462.14 1493.62C2438.1 1505.07 2416.66 1522.69 2396.48 1539.5C2378.93 1554.13 2361.94 1569.32 2346.54 1586.18C2326.26 1608.37 2307.33 1631.93 2290.01 1656.46C2286.28 1661.74 2282.65 1667.07 2279.05 1672.43C2275.98 1677 2272.91 1681.57 2269.84 1686.15C2266.4 1691.27 2261.72 1696.72 2259.3 1702.44C2257.19 1707.42 2261.53 1709.18 2264.52 1704.78C2268.12 1699.47 2271.5 1693.99 2275.14 1688.69C2279.97 1681.66 2284.81 1674.63 2289.68 1667.63C2323.5 1618.95 2363.62 1575.24 2410.26 1538.44C2429.13 1523.55 2448.36 1510.31 2469.59 1498.89C2488.25 1488.85 2508.41 1480.43 2528.16 1473.2C2547.35 1466.18 2566.77 1459.74 2587.06 1456.3C2603.52 1453.52 2620.28 1452.6 2637.02 1452.47C2658.27 1452.29 2679.35 1452.32 2700.46 1455.19C2711.43 1456.67 2722.32 1458.67 2733.26 1460.36C2735.23 1460.66 2737.3 1461.05 2739.28 1461.21C2745.87 1461.75 2746.65 1456.85 2744.37 1451.67Z",
    fill: "#C1DEE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1441.49 1258.78C1438.31 1261.27 1435.2 1263.81 1432.16 1266.46C1429.84 1268.48 1425.74 1270.9 1424.91 1273.95C1424.04 1277.13 1426.77 1280.11 1428.93 1282.03C1440.33 1292.19 1453.17 1299.06 1468.97 1300.2C1493.29 1301.96 1514.47 1295.95 1535.57 1284.1C1550.4 1275.78 1560.22 1263.48 1562.36 1246.87C1580.02 1253.98 1597.1 1263.77 1611.61 1275.8C1618.77 1281.74 1624.94 1288.31 1630.64 1295.6C1634.3 1300.27 1637.83 1305.01 1641.11 1309.93C1642.54 1312.07 1643.99 1315.87 1646.34 1317.1C1649.1 1318.55 1652.44 1316.28 1652.3 1313.3C1652.19 1310.83 1649.43 1307.96 1648.14 1305.93C1645.99 1302.57 1643.82 1299.23 1641.53 1295.96C1637.82 1290.66 1633.98 1285.44 1629.81 1280.49C1620.41 1269.36 1608.46 1260.16 1596.07 1252.32C1572.29 1237.28 1546.21 1227.8 1517.28 1227C1499.5 1226.5 1484.54 1232.39 1469.33 1241.18C1459.86 1246.65 1450.08 1252.03 1441.49 1258.78Z",
    fill: "#C7D1D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1632.65 1259.5C1614.17 1240.42 1595.61 1221.58 1574.96 1204.78C1562.79 1194.88 1549.96 1185.87 1537.4 1176.49C1538.84 1177.76 1540.27 1179.07 1541.65 1180.41C1537.73 1177.74 1532.6 1176.24 1528.44 1173.76C1523.8 1171.01 1519.37 1167.86 1515.02 1164.68C1506.53 1158.48 1498.17 1152.17 1489.45 1146.29C1479.73 1139.75 1469.65 1133.7 1459.77 1127.4C1451.38 1122.06 1442.88 1116.21 1433.91 1111.84C1429.01 1109.45 1424.11 1106.63 1419.2 1104.15C1417.55 1103.32 1400.87 1092.76 1400.91 1092.73C1401.84 1092.03 1410.23 1095.98 1411.53 1096.52C1415.32 1098.07 1418.95 1099.93 1422.59 1101.78C1420.59 1097.82 1419.01 1093.66 1418.15 1089.29C1417.88 1087.94 1415.75 1078.11 1416.84 1077.28C1417.38 1076.87 1422.71 1094.46 1422.98 1096.15C1423.2 1097.52 1423.17 1099.5 1423.62 1100.8C1424.34 1102.9 1424.31 1102.27 1425.9 1103.45C1428.82 1105.62 1432.71 1106.98 1435.87 1108.79C1437.58 1109.74 1442.86 1113.53 1446.05 1114.61C1455.68 1119.3 1465.44 1126.51 1474.59 1132.5C1472.19 1127.98 1470.36 1123.25 1469.03 1118.29C1468.71 1117.11 1465.29 1106.56 1466.12 1105.93C1467.05 1105.22 1473.57 1121.35 1473.96 1122.87C1474.68 1125.71 1474.82 1128.86 1475.72 1131.62C1476.71 1134.65 1479.78 1135.72 1482.55 1137.49C1492.75 1143.98 1502.6 1150.88 1512.28 1158.1C1522.85 1139.27 1510.67 1116.53 1500.4 1100.72C1493 1089.34 1483.04 1079.57 1472.51 1071.05C1458.47 1059.67 1442.41 1050.58 1426.37 1042.27C1407.67 1032.58 1387.47 1026.58 1366.46 1023.81C1355.47 1022.36 1344.23 1022.4 1333.14 1022.87C1327.72 1023.09 1322.51 1023.81 1317.32 1025.58C1314.97 1026.39 1312.71 1027.39 1310.51 1028.52C1308.83 1029.38 1304.78 1030.28 1303.81 1031.56C1295.88 1041.91 1291.83 1052.21 1292.45 1065.21C1293.03 1077.52 1296.91 1089.83 1302.17 1100.8C1308.03 1113.03 1315.57 1124.12 1325.43 1133.43C1332.95 1140.53 1341.36 1146.71 1349.71 1152.81C1379.42 1174.51 1417.09 1193.39 1455.57 1188.54C1468.03 1186.97 1479.87 1182.6 1490.94 1176.67C1493.55 1175.27 1496.15 1173.86 1498.61 1172.21C1500.27 1171.1 1504.71 1166.08 1506.38 1165.9C1508.66 1165.65 1513.6 1170.32 1515.74 1171.74C1532.06 1182.53 1547.96 1193.92 1563.52 1205.76C1580.07 1218.36 1595.82 1231.82 1611.1 1245.9C1617.59 1251.9 1624.05 1257.91 1630.36 1264.1C1631.83 1265.54 1635.42 1270.85 1638.09 1271.09C1639.77 1271.24 1640.91 1269.8 1640.67 1268.24C1640.25 1265.52 1634.55 1261.46 1632.65 1259.5Z",
    fill: "#C1DEE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1438,
    y: 878,
    width: 445,
    height: 633
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.2 878.577H1438.68V1510.33H1882.2V878.577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1466.87 1324.52C1463.79 1324.52 1460.72 1324.58 1457.65 1324.74C1455.31 1324.86 1451.73 1324.38 1449.75 1325.84C1447.69 1327.35 1447.83 1330.46 1448.15 1332.65C1449.85 1344.24 1454 1354.52 1462.68 1362.74C1476.05 1375.39 1491.38 1381.81 1509.51 1384.67C1522.25 1386.68 1534.01 1383.89 1543.38 1374.83C1550.24 1387.55 1555.43 1401.63 1558.04 1415.83C1559.33 1422.84 1559.72 1429.77 1559.49 1436.9C1559.35 1441.47 1559.1 1446.04 1558.61 1450.59C1558.39 1452.56 1557.39 1455.55 1558.16 1457.42C1559.07 1459.62 1562.13 1459.83 1563.5 1457.96C1564.65 1456.4 1564.44 1453.34 1564.67 1451.5C1565.06 1448.44 1565.42 1445.38 1565.68 1442.3C1566.1 1437.32 1566.41 1432.33 1566.39 1427.33C1566.34 1416.11 1563.84 1404.84 1560.43 1394.18C1553.88 1373.74 1543.26 1355.57 1526.73 1341.31C1516.57 1332.55 1504.94 1329 1491.75 1327.09C1483.53 1325.9 1475.19 1324.52 1466.87 1324.52Z",
    fill: "#89C5CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1514.31 1405.81C1481.11 1405.81 1458.74 1432.57 1448.17 1460.39C1444.18 1470.88 1443.25 1482.39 1441.71 1493.4C1441.22 1496.94 1441.4 1502.32 1439.97 1505.47C1439.45 1506.61 1438.26 1507.02 1438.83 1508.58C1439.17 1509.52 1439.85 1510.1 1440.87 1510.28C1442.96 1510.67 1445.91 1508.39 1447.7 1507.5C1462.55 1500.04 1472.31 1488.52 1480.27 1474.43C1485.21 1465.7 1490.21 1456.63 1493.14 1447.04C1494.93 1441.18 1495.98 1435.01 1496.59 1428.93C1496.83 1426.53 1497.06 1424.08 1497.05 1421.68C1497.03 1419.29 1495.92 1418.02 1495.12 1415.94C1506.2 1411.75 1518.71 1410.61 1529.93 1414.95C1540.31 1418.97 1548.93 1426.74 1553.76 1436.5C1555.02 1439.04 1555.98 1441.72 1556.69 1444.45C1557.15 1446.24 1557.17 1448.55 1558.03 1450.17C1560.1 1454.09 1564.46 1451.47 1564.04 1447.82C1562.87 1437.65 1557.05 1427.43 1549.61 1420.36C1540.23 1411.43 1527.51 1405.81 1514.31 1405.81Z",
    fill: "#89C5CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1863.62 878.577H1568.71C1558.45 878.577 1550.14 886.896 1550.14 897.158V1489.42C1550.14 1499.68 1558.45 1508 1568.71 1508H1863.62C1873.88 1508 1882.2 1499.68 1882.2 1489.42V897.158C1882.2 886.896 1873.88 878.577 1863.62 878.577Z",
    fill: "#C7D1D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1715 1470.84C1734.24 1470.84 1749.84 1455.24 1749.84 1436C1749.84 1416.76 1734.24 1401.16 1715 1401.16C1695.77 1401.16 1680.17 1416.76 1680.17 1436C1680.17 1455.24 1695.77 1470.84 1715 1470.84Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.82 920.384C1687.38 920.384 1689.46 918.304 1689.46 915.739C1689.46 913.173 1687.38 911.094 1684.82 911.094C1682.25 911.094 1680.17 913.173 1680.17 915.739C1680.17 918.304 1682.25 920.384 1684.82 920.384Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1745.19 911.094H1705.72C1703.15 911.094 1701.07 913.173 1701.07 915.739C1701.07 918.304 1703.15 920.384 1705.72 920.384H1745.19C1747.76 920.384 1749.84 918.304 1749.84 915.739C1749.84 913.173 1747.76 911.094 1745.19 911.094Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1587,
    y: 943,
    width: 256,
    height: 426
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.72 943.61H1587.29V1368.65H1842.72V943.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1587,
    y: 943,
    width: 256,
    height: 113
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.72 943.61H1587.29V1055.1H1842.72V943.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.43 943.61H1596.58C1591.45 943.61 1587.29 947.77 1587.29 952.901V1045.8C1587.29 1050.94 1591.45 1055.1 1596.58 1055.1H1833.43C1838.56 1055.1 1842.72 1050.94 1842.72 1045.8V952.901C1842.72 947.77 1838.56 943.61 1833.43 943.61Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1608,
    y: 977,
    width: 121,
    height: 45
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.94 977.056H1608.19V1021.65H1728.94V977.056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1721.97 977.056H1615.15C1611.31 977.056 1608.19 980.175 1608.19 984.024V986.811C1608.19 990.659 1611.31 993.779 1615.15 993.779H1721.97C1725.82 993.779 1728.94 990.659 1728.94 986.811V984.024C1728.94 980.175 1725.82 977.056 1721.97 977.056Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.27 1004.93H1615.15C1611.31 1004.93 1608.19 1008.05 1608.19 1011.89V1014.68C1608.19 1018.53 1611.31 1021.65 1615.15 1021.65H1682.27C1686.12 1021.65 1689.24 1018.53 1689.24 1014.68V1011.89C1689.24 1008.05 1686.12 1004.93 1682.27 1004.93Z",
    fill: "#C7D1D9"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1815.42 1015.61C1824.4 1015.61 1831.68 1008.33 1831.68 999.353C1831.68 990.374 1824.4 983.095 1815.42 983.095C1806.44 983.095 1799.17 990.374 1799.17 999.353C1799.17 1008.33 1806.44 1015.61 1815.42 1015.61Z",
    fill: "#C7D1D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1815.42 1006.32C1819.27 1006.32 1822.39 1003.2 1822.39 999.353C1822.39 995.505 1819.27 992.385 1815.42 992.385C1811.57 992.385 1808.45 995.505 1808.45 999.353C1808.45 1003.2 1811.57 1006.32 1815.42 1006.32Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1587,
    y: 1073,
    width: 256,
    height: 87
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.72 1073.68H1587.29V1159.61H1842.72V1073.68Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.43 1073.68H1596.58C1591.45 1073.68 1587.29 1077.84 1587.29 1082.97V1150.32C1587.29 1155.45 1591.45 1159.61 1596.58 1159.61H1833.43C1838.56 1159.61 1842.72 1155.45 1842.72 1150.32V1082.97C1842.72 1077.84 1838.56 1073.68 1833.43 1073.68Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1677,
    y: 1099,
    width: 122,
    height: 35
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.6 1099.46H1677.85V1133.83H1798.6V1099.46Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1792.16 1099.46H1684.3C1680.74 1099.46 1677.85 1102.34 1677.85 1105.9C1677.85 1109.46 1680.74 1112.35 1684.3 1112.35H1792.16C1795.71 1112.35 1798.6 1109.46 1798.6 1105.9C1798.6 1102.34 1795.71 1099.46 1792.16 1099.46Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.46 1120.94H1684.3C1680.74 1120.94 1677.85 1123.83 1677.85 1127.39C1677.85 1130.95 1680.74 1133.83 1684.3 1133.83H1752.46C1756.02 1133.83 1758.9 1130.95 1758.9 1127.39C1758.9 1123.83 1756.02 1120.94 1752.46 1120.94Z",
    fill: "#C7D1D9"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.05 1144.52C1651.44 1144.52 1663.92 1132.04 1663.92 1116.64C1663.92 1101.25 1651.44 1088.77 1636.05 1088.77C1620.66 1088.77 1608.19 1101.25 1608.19 1116.64C1608.19 1132.04 1620.66 1144.52 1636.05 1144.52Z",
    fill: "#C5CFD6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1587,
    y: 1178,
    width: 256,
    height: 87
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.72 1178.19H1587.29V1264.13H1842.72V1178.19Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1)"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.43 1178.19H1596.58C1591.45 1178.19 1587.29 1182.35 1587.29 1187.48V1254.84C1587.29 1259.97 1591.45 1264.13 1596.58 1264.13H1833.43C1838.56 1264.13 1842.72 1259.97 1842.72 1254.84V1187.48C1842.72 1182.35 1838.56 1178.19 1833.43 1178.19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1608,
    y: 1203,
    width: 121,
    height: 36
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.94 1203.97H1608.19V1238.35H1728.94V1203.97Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1722.49 1203.97H1614.63C1611.07 1203.97 1608.19 1206.86 1608.19 1210.42C1608.19 1213.98 1611.07 1216.86 1614.63 1216.86H1722.49C1726.05 1216.86 1728.94 1213.98 1728.94 1210.42C1728.94 1206.86 1726.05 1203.97 1722.49 1203.97Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.8 1225.46H1614.63C1611.07 1225.46 1608.19 1228.34 1608.19 1231.9C1608.19 1235.46 1611.07 1238.35 1614.63 1238.35H1682.8C1686.35 1238.35 1689.24 1235.46 1689.24 1231.9C1689.24 1228.34 1686.35 1225.46 1682.8 1225.46Z",
    fill: "#C7D1D9"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1815.42 1237.42C1824.4 1237.42 1831.68 1230.14 1831.68 1221.16C1831.68 1212.18 1824.4 1204.9 1815.42 1204.9C1806.44 1204.9 1799.17 1212.18 1799.17 1221.16C1799.17 1230.14 1806.44 1237.42 1815.42 1237.42Z",
    fill: "#C7D1D9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1815.42 1228.13C1819.27 1228.13 1822.39 1225.01 1822.39 1221.16C1822.39 1217.31 1819.27 1214.19 1815.42 1214.19C1811.57 1214.19 1808.45 1217.31 1808.45 1221.16C1808.45 1225.01 1811.57 1228.13 1815.42 1228.13Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1587,
    y: 1282,
    width: 256,
    height: 87
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.72 1282.71H1587.29V1368.65H1842.72V1282.71Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.43 1282.71H1596.58C1591.45 1282.71 1587.29 1286.87 1587.29 1292V1359.36C1587.29 1364.49 1591.45 1368.65 1596.58 1368.65H1833.43C1838.56 1368.65 1842.72 1364.49 1842.72 1359.36V1292C1842.72 1286.87 1838.56 1282.71 1833.43 1282.71Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1677,
    y: 1308,
    width: 122,
    height: 35
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.6 1308.49H1677.85V1342.87H1798.6V1308.49Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1792.16 1308.49H1684.3C1680.74 1308.49 1677.85 1311.38 1677.85 1314.94C1677.85 1318.5 1680.74 1321.38 1684.3 1321.38H1792.16C1795.71 1321.38 1798.6 1318.5 1798.6 1314.94C1798.6 1311.38 1795.71 1308.49 1792.16 1308.49Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.46 1329.98H1684.3C1680.74 1329.98 1677.85 1332.86 1677.85 1336.42C1677.85 1339.98 1680.74 1342.87 1684.3 1342.87H1752.46C1756.02 1342.87 1758.9 1339.98 1758.9 1336.42C1758.9 1332.86 1756.02 1329.98 1752.46 1329.98Z",
    fill: "#C7D1D9"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.05 1353.55C1651.44 1353.55 1663.92 1341.07 1663.92 1325.68C1663.92 1310.29 1651.44 1297.81 1636.05 1297.81C1620.66 1297.81 1608.19 1310.29 1608.19 1325.68C1608.19 1341.07 1620.66 1353.55 1636.05 1353.55Z",
    fill: "#C5CFD6"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1814,
    y: 985,
    width: 703,
    height: 723
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2516.13 985.417H1814.85V1707.75H2516.13V985.417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_1)"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2497.55 985.417H1833.43C1823.17 985.417 1814.85 993.736 1814.85 1004V1689.17C1814.85 1699.43 1823.17 1707.75 1833.43 1707.75H2497.55C2507.81 1707.75 2516.13 1699.43 2516.13 1689.17V1004C2516.13 993.736 2507.81 985.417 2497.55 985.417Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2465.04 1076H2355.9C2345.64 1076 2337.32 1084.32 2337.32 1094.58V1226.97C2337.32 1237.23 2345.64 1245.55 2355.9 1245.55H2465.04C2475.3 1245.55 2483.62 1237.23 2483.62 1226.97V1094.58C2483.62 1084.32 2475.3 1076 2465.04 1076Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2410.47 1173.37C2428.94 1173.37 2443.91 1158.33 2443.91 1139.78C2443.91 1121.23 2428.94 1106.19 2410.47 1106.19C2392 1106.19 2377.03 1121.23 2377.03 1139.78C2377.03 1158.33 2392 1173.37 2410.47 1173.37Z",
    fill: "#C7D1D9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2456.42 1181.77H2364.52C2361.04 1181.77 2358.22 1184.59 2358.22 1188.07C2358.22 1191.54 2361.04 1194.36 2364.52 1194.36H2456.42C2459.9 1194.36 2462.72 1191.54 2462.72 1188.07C2462.72 1184.59 2459.9 1181.77 2456.42 1181.77Z",
    fill: "#C7D1D9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2439.7 1202.76H2381.24C2377.76 1202.76 2374.94 1205.58 2374.94 1209.06C2374.94 1212.54 2377.76 1215.36 2381.24 1215.36H2439.7C2443.18 1215.36 2446 1212.54 2446 1209.06C2446 1205.58 2443.18 1202.76 2439.7 1202.76Z",
    fill: "#C7D1D9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.85 1004C1814.85 993.737 1823.17 985.417 1833.43 985.417H2497.55C2507.81 985.417 2516.13 993.737 2516.13 1004V1041.16H1814.85V1004Z",
    fill: "#C5CFD6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1845.04 1027.22C1850.17 1027.22 1854.33 1023.06 1854.33 1017.93C1854.33 1012.8 1850.17 1008.64 1845.04 1008.64C1839.91 1008.64 1835.75 1012.8 1835.75 1017.93C1835.75 1023.06 1839.91 1027.22 1845.04 1027.22Z",
    fill: "#F2F2F2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.91 1027.22C1878.04 1027.22 1882.2 1023.06 1882.2 1017.93C1882.2 1012.8 1878.04 1008.64 1872.91 1008.64C1867.78 1008.64 1863.62 1012.8 1863.62 1017.93C1863.62 1023.06 1867.78 1027.22 1872.91 1027.22Z",
    fill: "#F2F2F2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1900.77 1027.22C1905.9 1027.22 1910.06 1023.06 1910.06 1017.93C1910.06 1012.8 1905.9 1008.64 1900.77 1008.64C1895.64 1008.64 1891.48 1012.8 1891.48 1017.93C1891.48 1023.06 1895.64 1027.22 1900.77 1027.22Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2337,
    y: 1261,
    width: 147,
    height: 405
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2483.62 1261.81H2337.32V1665.94H2483.62V1261.81Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_1)"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2465.04 1261.81H2355.9C2345.64 1261.81 2337.32 1270.13 2337.32 1280.39V1647.36C2337.32 1657.62 2345.64 1665.94 2355.9 1665.94H2465.04C2475.3 1665.94 2483.62 1657.62 2483.62 1647.36V1280.39C2483.62 1270.13 2475.3 1261.81 2465.04 1261.81Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2379,
    y: 1303,
    width: 63,
    height: 333
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2441.82 1303.61H2379.12V1635.75H2441.82V1303.61Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2432.53 1303.61H2388.41C2383.28 1303.61 2379.12 1307.77 2379.12 1312.9V1347.74C2379.12 1352.87 2383.28 1357.03 2388.41 1357.03H2432.53C2437.66 1357.03 2441.82 1352.87 2441.82 1347.74V1312.9C2441.82 1307.77 2437.66 1303.61 2432.53 1303.61Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.53 1375.62H2388.41C2383.28 1375.62 2379.12 1379.77 2379.12 1384.91V1417.42C2379.12 1422.55 2383.28 1426.71 2388.41 1426.71H2432.53C2437.66 1426.71 2441.82 1422.55 2441.82 1417.42V1384.91C2441.82 1379.77 2437.66 1375.62 2432.53 1375.62Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.53 1445.29H2388.41C2383.28 1445.29 2379.12 1449.45 2379.12 1454.58V1487.1C2379.12 1492.23 2383.28 1496.39 2388.41 1496.39H2432.53C2437.66 1496.39 2441.82 1492.23 2441.82 1487.1V1454.58C2441.82 1449.45 2437.66 1445.29 2432.53 1445.29Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.53 1584.65H2388.41C2383.28 1584.65 2379.12 1588.81 2379.12 1593.94V1626.46C2379.12 1631.59 2383.28 1635.75 2388.41 1635.75H2432.53C2437.66 1635.75 2441.82 1631.59 2441.82 1626.46V1593.94C2441.82 1588.81 2437.66 1584.65 2432.53 1584.65Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.53 1514.97H2388.41C2383.28 1514.97 2379.12 1519.13 2379.12 1524.26V1556.78C2379.12 1561.91 2383.28 1566.07 2388.41 1566.07H2432.53C2437.66 1566.07 2441.82 1561.91 2441.82 1556.78V1524.26C2441.82 1519.13 2437.66 1514.97 2432.53 1514.97Z",
    fill: "#C5CFD6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1087,
    width: 446,
    height: 586
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1087.61H1852.01V1672.91H2297.85V1087.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1087,
    width: 446,
    height: 99
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1087.61H1852.01V1185.16H2297.85V1087.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_0_1)"
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1087.61H1861.3C1856.17 1087.61 1852.01 1091.77 1852.01 1096.9V1175.87C1852.01 1181 1856.17 1185.16 1861.3 1185.16H2288.56C2293.69 1185.16 2297.85 1181 2297.85 1175.87V1096.9C2297.85 1091.77 2293.69 1087.61 2288.56 1087.61Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1116,
    width: 313,
    height: 40
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1116.88H1872.91V1155.9H2184.07V1116.88Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2177.1 1116.88H1879.87C1876.03 1116.88 1872.91 1120 1872.91 1123.84V1124.54C1872.91 1128.39 1876.03 1131.51 1879.87 1131.51H2177.1C2180.95 1131.51 2184.07 1128.39 2184.07 1124.54V1123.84C2184.07 1120 2180.95 1116.88 2177.1 1116.88Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.8 1141.26H1879.87C1876.03 1141.26 1872.91 1144.38 1872.91 1148.23V1148.93C1872.91 1152.78 1876.03 1155.9 1879.87 1155.9H2074.8C2078.65 1155.9 2081.77 1152.78 2081.77 1148.93V1148.23C2081.77 1144.38 2078.65 1141.26 2074.8 1141.26Z",
    fill: "#C7D1D9"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1152.64C2259.18 1152.64 2266.46 1145.37 2266.46 1136.39C2266.46 1127.41 2259.18 1120.13 2250.2 1120.13C2241.22 1120.13 2233.95 1127.41 2233.95 1136.39C2233.95 1145.37 2241.22 1152.64 2250.2 1152.64Z",
    fill: "#C7D1D9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1143.35C2254.05 1143.35 2257.17 1140.23 2257.17 1136.39C2257.17 1132.54 2254.05 1129.42 2250.2 1129.42C2246.35 1129.42 2243.24 1132.54 2243.24 1136.39C2243.24 1140.23 2246.35 1143.35 2250.2 1143.35Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1203,
    width: 446,
    height: 80
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1203.74H1852.01V1282.71H2297.85V1203.74Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_0_1)"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1203.74H1861.3C1856.17 1203.74 1852.01 1207.9 1852.01 1213.03V1273.42C1852.01 1278.55 1856.17 1282.71 1861.3 1282.71H2288.56C2293.69 1282.71 2297.85 1278.55 2297.85 1273.42V1213.03C2297.85 1207.9 2293.69 1203.74 2288.56 1203.74Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1227,
    width: 313,
    height: 33
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1227.43H1872.91V1259.02H2184.07V1227.43Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2178.15 1227.43H1878.83C1875.56 1227.43 1872.91 1230.08 1872.91 1233.36C1872.91 1236.63 1875.56 1239.28 1878.83 1239.28H2178.15C2181.42 1239.28 2184.07 1236.63 2184.07 1233.36C2184.07 1230.08 2181.42 1227.43 2178.15 1227.43Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075.85 1247.18H1878.83C1875.56 1247.18 1872.91 1249.83 1872.91 1253.1C1872.91 1256.37 1875.56 1259.02 1878.83 1259.02H2075.85C2079.12 1259.02 2081.77 1256.37 2081.77 1253.1C2081.77 1249.83 2079.12 1247.18 2075.85 1247.18Z",
    fill: "#C7D1D9"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1259.48C2259.18 1259.48 2266.46 1252.21 2266.46 1243.23C2266.46 1234.25 2259.18 1226.97 2250.2 1226.97C2241.22 1226.97 2233.95 1234.25 2233.95 1243.23C2233.95 1252.21 2241.22 1259.48 2250.2 1259.48Z",
    fill: "#C7D1D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1250.19C2254.05 1250.19 2257.17 1247.07 2257.17 1243.23C2257.17 1239.38 2254.05 1236.26 2250.2 1236.26C2246.35 1236.26 2243.24 1239.38 2243.24 1243.23C2243.24 1247.07 2246.35 1250.19 2250.2 1250.19Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1301,
    width: 446,
    height: 80
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1301.29H1852.01V1380.26H2297.85V1301.29Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_0_1)"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1301.29H1861.3C1856.17 1301.29 1852.01 1305.45 1852.01 1310.58V1370.97C1852.01 1376.1 1856.17 1380.26 1861.3 1380.26H2288.56C2293.69 1380.26 2297.85 1376.1 2297.85 1370.97V1310.58C2297.85 1305.45 2293.69 1301.29 2288.56 1301.29Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1324,
    width: 313,
    height: 33
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1324.98H1872.91V1356.57H2184.07V1324.98Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2178.15 1324.98H1878.83C1875.56 1324.98 1872.91 1327.63 1872.91 1330.91C1872.91 1334.18 1875.56 1336.83 1878.83 1336.83H2178.15C2181.42 1336.83 2184.07 1334.18 2184.07 1330.91C2184.07 1327.63 2181.42 1324.98 2178.15 1324.98Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075.85 1344.72H1878.83C1875.56 1344.72 1872.91 1347.38 1872.91 1350.65C1872.91 1353.92 1875.56 1356.57 1878.83 1356.57H2075.85C2079.12 1356.57 2081.77 1353.92 2081.77 1350.65C2081.77 1347.38 2079.12 1344.72 2075.85 1344.72Z",
    fill: "#C7D1D9"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1357.03C2259.18 1357.03 2266.46 1349.76 2266.46 1340.78C2266.46 1331.8 2259.18 1324.52 2250.2 1324.52C2241.22 1324.52 2233.95 1331.8 2233.95 1340.78C2233.95 1349.76 2241.22 1357.03 2250.2 1357.03Z",
    fill: "#C7D1D9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1347.74C2254.05 1347.74 2257.17 1344.62 2257.17 1340.78C2257.17 1336.93 2254.05 1333.81 2250.2 1333.81C2246.35 1333.81 2243.24 1336.93 2243.24 1340.78C2243.24 1344.62 2246.35 1347.74 2250.2 1347.74Z",
    fill: "#AFB9C5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1593,
    width: 446,
    height: 80
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1593.94H1852.01V1672.91H2297.85V1593.94Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_0_1)"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1593.94H1861.3C1856.17 1593.94 1852.01 1598.1 1852.01 1603.23V1663.62C1852.01 1668.75 1856.17 1672.91 1861.3 1672.91H2288.56C2293.69 1672.91 2297.85 1668.75 2297.85 1663.62V1603.23C2297.85 1598.1 2293.69 1593.94 2288.56 1593.94Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1617,
    width: 313,
    height: 33
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1617.63H1872.91V1649.22H2184.07V1617.63Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2178.15 1617.63H1878.83C1875.56 1617.63 1872.91 1620.28 1872.91 1623.55C1872.91 1626.82 1875.56 1629.48 1878.83 1629.48H2178.15C2181.42 1629.48 2184.07 1626.82 2184.07 1623.55C2184.07 1620.28 2181.42 1617.63 2178.15 1617.63Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075.85 1637.37H1878.83C1875.56 1637.37 1872.91 1640.02 1872.91 1643.3C1872.91 1646.57 1875.56 1649.22 1878.83 1649.22H2075.85C2079.12 1649.22 2081.77 1646.57 2081.77 1643.3C2081.77 1640.02 2079.12 1637.37 2075.85 1637.37Z",
    fill: "#C7D1D9"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1649.68C2259.18 1649.68 2266.46 1642.4 2266.46 1633.42C2266.46 1624.45 2259.18 1617.17 2250.2 1617.17C2241.22 1617.17 2233.95 1624.45 2233.95 1633.42C2233.95 1642.4 2241.22 1649.68 2250.2 1649.68Z",
    fill: "#C7D1D9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1640.39C2254.05 1640.39 2257.17 1637.27 2257.17 1633.42C2257.17 1629.58 2254.05 1626.46 2250.2 1626.46C2246.35 1626.46 2243.24 1629.58 2243.24 1633.42C2243.24 1637.27 2246.35 1640.39 2250.2 1640.39Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1496,
    width: 446,
    height: 80
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1496.39H1852.01V1575.36H2297.85V1496.39Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_0_1)"
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1496.39H1861.3C1856.17 1496.39 1852.01 1500.55 1852.01 1505.68V1566.07C1852.01 1571.2 1856.17 1575.36 1861.3 1575.36H2288.56C2293.69 1575.36 2297.85 1571.2 2297.85 1566.07V1505.68C2297.85 1500.55 2293.69 1496.39 2288.56 1496.39Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1520,
    width: 313,
    height: 32
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1520.08H1872.91V1551.67H2184.07V1520.08Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2178.15 1520.08H1878.83C1875.56 1520.08 1872.91 1522.73 1872.91 1526C1872.91 1529.27 1875.56 1531.93 1878.83 1531.93H2178.15C2181.42 1531.93 2184.07 1529.27 2184.07 1526C2184.07 1522.73 2181.42 1520.08 2178.15 1520.08Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075.85 1539.82H1878.83C1875.56 1539.82 1872.91 1542.47 1872.91 1545.75C1872.91 1549.02 1875.56 1551.67 1878.83 1551.67H2075.85C2079.12 1551.67 2081.77 1549.02 2081.77 1545.75C2081.77 1542.47 2079.12 1539.82 2075.85 1539.82Z",
    fill: "#C7D1D9"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1552.13C2259.18 1552.13 2266.46 1544.85 2266.46 1535.87C2266.46 1526.9 2259.18 1519.62 2250.2 1519.62C2241.22 1519.62 2233.95 1526.9 2233.95 1535.87C2233.95 1544.85 2241.22 1552.13 2250.2 1552.13Z",
    fill: "#C7D1D9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1542.84C2254.05 1542.84 2257.17 1539.72 2257.17 1535.87C2257.17 1532.03 2254.05 1528.91 2250.2 1528.91C2246.35 1528.91 2243.24 1532.03 2243.24 1535.87C2243.24 1539.72 2246.35 1542.84 2250.2 1542.84Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1852,
    y: 1398,
    width: 446,
    height: 80
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.85 1398.84H1852.01V1477.81H2297.85V1398.84Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_0_1)"
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M2288.56 1398.84H1861.3C1856.17 1398.84 1852.01 1403 1852.01 1408.13V1468.52C1852.01 1473.65 1856.17 1477.81 1861.3 1477.81H2288.56C2293.69 1477.81 2297.85 1473.65 2297.85 1468.52V1408.13C2297.85 1403 2293.69 1398.84 2288.56 1398.84Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1872,
    y: 1422,
    width: 313,
    height: 33
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.07 1422.53H1872.91V1454.12H2184.07V1422.53Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2178.15 1422.53H1878.83C1875.56 1422.53 1872.91 1425.18 1872.91 1428.45C1872.91 1431.73 1875.56 1434.38 1878.83 1434.38H2178.15C2181.42 1434.38 2184.07 1431.73 2184.07 1428.45C2184.07 1425.18 2181.42 1422.53 2178.15 1422.53Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075.85 1442.27H1878.83C1875.56 1442.27 1872.91 1444.93 1872.91 1448.2C1872.91 1451.47 1875.56 1454.12 1878.83 1454.12H2075.85C2079.12 1454.12 2081.77 1451.47 2081.77 1448.2C2081.77 1444.93 2079.12 1442.27 2075.85 1442.27Z",
    fill: "#C7D1D9"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1454.58C2259.18 1454.58 2266.46 1447.3 2266.46 1438.33C2266.46 1429.35 2259.18 1422.07 2250.2 1422.07C2241.22 1422.07 2233.95 1429.35 2233.95 1438.33C2233.95 1447.3 2241.22 1454.58 2250.2 1454.58Z",
    fill: "#C7D1D9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M2250.2 1445.29C2254.05 1445.29 2257.17 1442.17 2257.17 1438.33C2257.17 1434.48 2254.05 1431.36 2250.2 1431.36C2246.35 1431.36 2243.24 1434.48 2243.24 1438.33C2243.24 1442.17 2246.35 1445.29 2250.2 1445.29Z",
    fill: "#F2F2F2"
  }))))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.95 1522.45C1242.83 1588.02 1288.12 1651.52 1315.31 1723.21C1314.22 1714.76 1313.06 1706.32 1311.76 1697.89C1304.85 1653.2 1296.28 1608.84 1287.26 1564.53C1282.68 1541.97 1277.82 1519.5 1272.84 1497.02C1270.16 1484.95 1267.52 1472.87 1264.79 1460.81C1264.13 1457.89 1263.56 1452.79 1262.73 1447.62C1289.16 1534.8 1314.65 1622.06 1333.29 1711.34C1335.74 1723.06 1337.82 1734.75 1339.53 1746.43C1340.11 1743.77 1340.68 1741.1 1341.31 1738.45C1348.85 1706.6 1360.17 1675.01 1373.64 1645.24C1380.08 1631 1387.48 1617.07 1396.19 1604.09C1401.63 1596 1414.44 1586.39 1419.39 1578.1C1392.29 1628.07 1382.5 1690.59 1366.86 1744.91C1363.04 1758.16 1359.2 1771.4 1355.43 1784.66C1379.03 1737.08 1415.64 1698 1466.54 1681.06C1404.92 1721.99 1367.97 1793.66 1343.06 1866.96C1342.98 1867.83 1342.88 1868.7 1342.8 1869.57C1350.13 1855.59 1359.36 1842.94 1371.87 1834.08C1398.65 1815.12 1428.35 1820.65 1454.33 1836.91C1433.94 1823.89 1397.1 1835.75 1379.94 1848.99C1367.66 1858.47 1357.17 1871.18 1348.06 1883.59C1345.87 1886.56 1342.89 1890.03 1339.75 1893.73C1335.33 1922.53 1328.14 1951.12 1317.96 1979.49C1319.64 1971.35 1318.43 1958.33 1318.89 1952.26C1318.94 1951.6 1318.99 1950.94 1319.04 1950.29C1317.49 1956.5 1315.99 1962.64 1314.55 1968.68C1317.41 1957.15 1318.97 1945.12 1320.18 1932.96C1320.5 1927.73 1320.8 1922.51 1321.13 1917.28C1321.02 1907.36 1320.62 1897.4 1319.93 1887.43C1317.49 1877.74 1314.76 1868.6 1312.51 1861C1304.39 1833.56 1292.49 1807.28 1277.84 1782.76C1264.47 1760.39 1248.47 1740.12 1230 1721.79C1220.04 1711.91 1209.62 1702.51 1199.35 1692.97C1195.63 1689.52 1188.99 1681.04 1183.25 1676.62C1225.07 1699.8 1268.13 1724.88 1298.64 1762.23C1295.06 1748.43 1291.18 1734.81 1287.07 1721.47C1266.22 1653.78 1239.89 1583.63 1203.95 1522.45Z",
    fill: "#C7D1D9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.86 2030.59C1379.31 2030.59 1417.78 1999.91 1417.78 1962.07C1417.78 1924.23 1379.31 1893.56 1331.86 1893.56C1284.41 1893.56 1245.94 1924.23 1245.94 1962.07C1245.94 1999.91 1284.41 2030.59 1331.86 2030.59Z",
    fill: "#C5CFD6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M2711.18 919.223C2711.18 916.016 2708.58 913.416 2705.38 913.416C2702.17 913.416 2699.57 916.016 2699.57 919.223V958.707C2699.57 961.914 2702.17 964.514 2705.38 964.514C2708.58 964.514 2711.18 961.914 2711.18 958.707V919.223Z",
    fill: "#C7D1D9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2741.37 884.384C2741.37 881.177 2738.77 878.577 2735.56 878.577C2732.36 878.577 2729.76 881.177 2729.76 884.384V958.707C2729.76 961.914 2732.36 964.514 2735.56 964.514C2738.77 964.514 2741.37 961.914 2741.37 958.707V884.384Z",
    fill: "#C7D1D9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2771.56 868.126C2771.56 864.919 2768.96 862.319 2765.75 862.319C2762.54 862.319 2759.94 864.919 2759.94 868.126V958.707C2759.94 961.914 2762.54 964.514 2765.75 964.514C2768.96 964.514 2771.56 961.914 2771.56 958.707V868.126Z",
    fill: "#C7D1D9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2799.42 884.384C2799.42 881.177 2796.82 878.577 2793.61 878.577C2790.41 878.577 2787.81 881.177 2787.81 884.384V958.707C2787.81 961.914 2790.41 964.514 2793.61 964.514C2796.82 964.514 2799.42 961.914 2799.42 958.707V884.384Z",
    fill: "#C7D1D9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M2829.61 851.867C2829.61 848.66 2827.01 846.061 2823.8 846.061C2820.6 846.061 2818 848.66 2818 851.867V958.707C2818 961.914 2820.6 964.514 2823.8 964.514C2827.01 964.514 2829.61 961.914 2829.61 958.707V851.867Z",
    fill: "#C5CFD6"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1095.01 1414.96C1095.01 1392.05 1113.82 1373.29 1136.8 1373.29V1414.96L1108.24 1445.29C1100.12 1437.88 1095.01 1427 1095.01 1414.96Z",
    fill: "#F2F2F2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135.84 1412.78H1178.6C1178.6 1423.69 1174.09 1433.92 1166.96 1441.35C1159.12 1449.47 1147.96 1454.58 1135.84 1454.58C1124.68 1454.58 1114.46 1450.18 1106.62 1443.21L1135.84 1412.78Z",
    fill: "#AFB9C5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1178.6 1415.1C1178.6 1392.11 1159.79 1373.29 1136.8 1373.29V1415.1H1178.6ZM1115.91 1373.29L1132.63 1410.92L1095.01 1394.2C1098.73 1384.44 1107.08 1377.01 1115.91 1373.29Z",
    fill: "#C5CFD6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2883.33 1519.25C2879.3 1523.43 2873.58 1526.06 2867.23 1526.06C2855.02 1526.06 2845.12 1516.42 2845.12 1504.52C2845.12 1492.62 2855.02 1482.98 2867.23 1482.98V1442.97C2832.49 1442.97 2804.06 1470.67 2804.06 1504.52C2804.06 1538.36 2832.49 1566.07 2867.23 1566.07C2885.47 1566.07 2901.96 1558.55 2913.2 1546.58L2883.33 1519.25Z",
    fill: "#F2F2F2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2866.76 1442.97V1483.73C2878.88 1483.73 2888.7 1493.56 2888.7 1505.68H2929.46C2929.46 1471.2 2901.24 1442.97 2866.76 1442.97Z",
    fill: "#AFB9C5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2887.09 1505.68C2887.09 1512.6 2883.68 1518.76 2878.37 1522.73L2904.47 1554.46C2919.66 1543.1 2929.46 1525.5 2929.46 1505.68H2887.09Z",
    fill: "#C5CFD6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2573.88 872.553C2570.71 875.79 2566.21 877.823 2561.21 877.823C2551.6 877.823 2543.8 870.362 2543.8 861.158C2543.8 851.953 2551.6 844.493 2561.21 844.493V813.544C2533.86 813.544 2511.48 834.975 2511.48 861.158C2511.48 887.341 2533.86 908.771 2561.21 908.771C2575.57 908.771 2588.55 902.953 2597.4 893.698L2573.88 872.553Z",
    fill: "#F2F2F2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2560.24 813.544V845.248C2569.67 845.248 2577.31 852.892 2577.31 862.319H2609.01C2609.01 835.498 2587.06 813.544 2560.24 813.544Z",
    fill: "#AFB9C5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2578.2 862.319C2578.2 867.594 2575.71 872.283 2571.86 875.312L2590.84 899.481C2601.89 890.829 2609.01 877.416 2609.01 862.319H2578.2Z",
    fill: "#C5CFD6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.5 866.932C1271.49 866.955 1271.48 866.979 1271.47 867.007C1271.48 866.983 1271.5 866.89 1271.5 866.932Z",
    fill: "#C5CFD6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.48 866.967C1271.48 866.972 1271.48 866.981 1271.48 866.991C1271.48 866.967 1271.52 866.896 1271.48 866.967Z",
    fill: "#C5CFD6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.64 866.574C1271.61 866.667 1271.57 866.755 1271.53 866.848C1271.55 866.802 1271.57 866.765 1271.59 866.718C1271.1 867.926 1271.41 867.141 1271.64 866.574Z",
    fill: "#C5CFD6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.54 866.855C1271.52 866.897 1271.5 866.944 1271.48 866.986C1271.35 867.247 1271.54 866.855 1271.54 866.855Z",
    fill: "#C5CFD6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.46 867.002C1271.59 866.787 1271.43 867.058 1271.46 867.002Z",
    fill: "#C5CFD6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.48 866.969L1271.49 866.96C1271.49 866.964 1271.49 866.969 1271.48 866.969Z",
    fill: "#C5CFD6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.05 757.802H1180.92C1175.79 757.802 1171.64 761.961 1171.64 767.092V880.9C1171.64 886.031 1175.79 890.19 1180.92 890.19H1362.05C1367.18 890.19 1371.34 886.031 1371.34 880.9V767.092C1371.34 761.961 1367.18 757.802 1362.05 757.802Z",
    fill: "#C7D1D9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1246.41 794.963L1187.89 890.19H1304.92L1246.41 794.963Z",
    fill: "#AFB9C5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.88 820.357L1252.68 890.19H1355.08L1303.88 820.357Z",
    fill: "#C5CFD6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.22 820.512C1337.48 820.512 1345.79 812.193 1345.79 801.931C1345.79 791.669 1337.48 783.35 1327.22 783.35C1316.96 783.35 1308.64 791.669 1308.64 801.931C1308.64 812.193 1316.96 820.512 1327.22 820.512Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2615.96 1756.49C2615.97 1756.51 2615.98 1756.54 2615.99 1756.56C2615.98 1756.54 2615.96 1756.45 2615.96 1756.49Z",
    fill: "#C5CFD6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2615.98 1756.53C2615.98 1756.53 2615.98 1756.54 2615.98 1756.55C2615.98 1756.53 2615.94 1756.45 2615.98 1756.53Z",
    fill: "#C5CFD6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2615.82 1756.13C2615.85 1756.23 2615.89 1756.31 2615.93 1756.41C2615.91 1756.36 2615.89 1756.32 2615.88 1756.28C2616.36 1757.48 2616.05 1756.7 2615.82 1756.13Z",
    fill: "#C5CFD6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2615.92 1756.41C2615.94 1756.46 2615.96 1756.5 2615.98 1756.54C2616.12 1756.81 2615.92 1756.41 2615.92 1756.41Z",
    fill: "#C5CFD6"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2616 1756.56C2616.03 1756.62 2615.87 1756.35 2616 1756.56Z",
    fill: "#C5CFD6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2615.98 1756.53L2615.97 1756.52C2615.98 1756.52 2615.98 1756.53 2615.98 1756.53Z",
    fill: "#C5CFD6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M2460.4 1577.68H2771.55C2776.68 1577.68 2780.84 1581.84 2780.84 1586.97V1786.72C2780.84 1791.85 2776.68 1796.01 2771.55 1796.01H2460.4C2455.27 1796.01 2451.11 1791.85 2451.11 1786.72V1586.97C2451.11 1581.84 2455.27 1577.68 2460.4 1577.68Z",
    fill: "#C7D1D9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2658.41 1640.39L2753.74 1796.01H2563.08L2658.41 1640.39Z",
    fill: "#AFB9C5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2560.11 1682.08L2644.4 1796.01H2475.83L2560.11 1682.08Z",
    fill: "#C5CFD6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2524.25 1682.2C2506.94 1682.2 2492.9 1668.16 2492.9 1650.84C2492.9 1633.53 2506.94 1619.49 2524.25 1619.49C2541.57 1619.49 2555.6 1633.53 2555.6 1650.84C2555.6 1668.16 2541.57 1682.2 2524.25 1682.2Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2502.34 1276.31C2487.31 1285.38 2472.53 1289.76 2465.6 1287.97C2448.2 1283.48 2446.61 1219.85 2460.06 1194.76C2473.52 1169.68 2542.69 1158.74 2546.18 1208.45C2547.39 1225.7 2540.15 1241.09 2529.45 1253.66L2548.63 1343.1H2492.9L2502.34 1276.31Z",
    fill: "#915B3C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2527.74 1196.77C2495.58 1197 2473.2 1195.65 2460.4 1192.13C2460.98 1181.23 2472.31 1168.9 2502.19 1168.9C2535.44 1168.9 2553.28 1188.29 2553.28 1210.71C2553.28 1231.2 2540.09 1256.15 2530.06 1257.16C2527.46 1256.59 2525.24 1253.47 2523.04 1249.16C2527.17 1247.2 2530.06 1242.68 2530.06 1237.42C2530.06 1230.36 2524.86 1224.65 2518.45 1224.65C2516.12 1224.65 2513.95 1225.4 2512.13 1226.7C2507.92 1219.89 2502.63 1214.8 2495.23 1215.36L2499.87 1201.42L2527.74 1199.1V1196.77Z",
    fill: "#B58143"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2553.28 1535.88L2439.31 1824.41L2362.86 2068.33H2332.68L2454.19 1535.88H2553.28Z",
    fill: "#915B3C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2576.23 1535.88C2577.44 1637.27 2595.14 1773.77 2597.97 1780.09C2600.8 1786.41 2793.21 1940.84 2793.21 1940.84L2772.42 1963.09C2772.42 1963.09 2545.39 1830.69 2534.89 1813.03C2524.38 1795.38 2490.18 1632.87 2462.72 1535.88H2576.23Z",
    fill: "#915B3C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2789.86 1936.67C2790.62 1934.06 2793.37 1932.51 2795.93 1933.44C2800.59 1935.14 2807.4 1937.9 2810.42 1940.43C2815.23 1944.47 2823.11 1953.82 2823.11 1953.82C2818.43 1959.41 2738.93 2054.17 2738.93 2054.17C2738.93 2054.17 2722.72 2047.23 2728.76 2037.94C2734.8 2028.65 2738.64 2022.38 2738.64 2022.38L2756.98 1958.29C2757.34 1957.03 2758.67 1956.32 2759.92 1956.71L2769.7 1959.82C2769.7 1959.82 2779.89 1955.07 2783.98 1950.19C2786.47 1947.22 2788.59 1941.05 2789.86 1936.67Z",
    fill: "#E4E4E4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2368.79 2054.48C2371.28 2053.38 2374.24 2054.49 2375.16 2057.05C2376.85 2061.71 2379.12 2068.7 2379.12 2072.64C2379.12 2078.93 2377.03 2090.98 2377.03 2090.98C2369.74 2090.98 2246.06 2090.98 2246.06 2090.98C2246.06 2090.98 2240.95 2074.1 2251.95 2072.75C2262.95 2071.41 2270.23 2070.32 2270.23 2070.32L2331.1 2043.18C2332.3 2042.64 2333.69 2043.2 2334.19 2044.41L2338.11 2053.91C2338.11 2053.91 2348.29 2058.66 2354.65 2058.66C2358.53 2058.66 2364.62 2056.31 2368.79 2054.48Z",
    fill: "#E4E4E4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2476.65 2043.21L2333.14 2027.63L2448.78 1535.88H2568.04L2476.65 2043.21Z",
    fill: "#191847"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2763.52 1904.94L2669.38 2016.39C2669.38 2016.39 2520.65 1853.91 2495.96 1804.36C2471.27 1754.8 2451.57 1535.88 2451.57 1535.88H2596.29C2596.29 1535.88 2607.05 1728.48 2610.79 1737.44C2614.54 1746.4 2763.52 1904.94 2763.52 1904.94Z",
    fill: "#393F82"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2296.99 1563.18L2362.77 1499L2384.61 1536.81L2316.21 1577.15C2299.06 1604.17 2288.99 1615.85 2285.99 1612.18C2283.46 1609.08 2284.62 1605.69 2285.69 1602.56C2286.52 1600.13 2287.29 1597.86 2286.23 1596.02C2283.8 1591.81 2270.07 1594.22 2257.13 1597.06C2244.19 1599.9 2247.19 1593.55 2249.94 1590.23C2262.16 1580.36 2277.84 1571.35 2296.99 1563.18ZM2684.71 1656.44C2677.91 1642.63 2654.74 1508.05 2654.74 1508.05L2606.21 1508.24C2606.21 1508.24 2651.15 1653.36 2654.74 1662.24C2659.39 1673.77 2651.48 1690.53 2646.12 1701.89C2645.3 1703.65 2644.53 1705.28 2643.88 1706.74C2651.31 1710.07 2654.88 1706.05 2658.65 1701.81C2662.91 1697.02 2667.41 1691.95 2678 1696.88C2682.1 1698.78 2685.97 1701.03 2689.75 1703.24C2702.83 1710.83 2714.84 1717.82 2731.18 1707.73C2733.77 1706.14 2736.6 1700.12 2729.75 1695.41C2712.66 1683.7 2688.04 1663.19 2684.71 1656.44Z",
    fill: "#915B3C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2516.83 1304.39L2496.75 1300.94C2462.18 1387.32 2401.83 1465.8 2315.69 1536.4L2380.78 1615.5C2466.91 1514.98 2520 1411.28 2516.83 1304.39Z",
    fill: "#C21B15"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2604.36 1556.78H2425.56C2425.56 1556.78 2487.7 1405.66 2487.7 1300.04L2541.64 1292C2584.02 1360.19 2595.99 1444.14 2604.36 1556.78Z",
    fill: "#C7D1D9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2685.64 1633.42C2666.08 1412.77 2542.82 1292 2542.82 1292L2542.78 1292.04C2542.77 1292.03 2542.76 1292.01 2542.75 1292H2539.23C2532.92 1292.22 2519.98 1292.79 2519.98 1292.79L2506.95 1330.04C2504.88 1398.17 2482.8 1604.64 2482.8 1604.64H2599.84C2599.64 1614.1 2599.2 1623.7 2598.49 1633.42H2685.64Z",
    fill: "#FF4133"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2599.82 1605.55C2600.75 1564.33 2597.09 1525.62 2590.99 1490.59C2587.8 1532.16 2581.14 1582.17 2567.21 1605.55H2599.82Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2573.92 1533.55L2516.12 1506.68V1533.55H2573.92Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1963.32 1445.86C1978.36 1454.93 1993.13 1459.31 2000.07 1457.52C2017.46 1453.03 2019.05 1389.4 2005.6 1364.31C1992.14 1339.23 1922.97 1328.29 1919.48 1378C1918.27 1395.25 1925.51 1410.64 1936.21 1423.21L1917.03 1512.65H1972.76L1963.32 1445.86Z",
    fill: "#DCAE92"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1816.3 1802.97H1995.69L2019.2 2090.98H1752.16L1816.3 1802.97Z",
    fill: "#C5CFD6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1816.3 1802.97H1871.47L1904.5 2090.98H1752.16L1816.3 1802.97Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2094.26 1860.03C2074.1 1902.8 2042.6 2006.6 2042.6 2006.6L2069.34 2018.82C2069.34 2018.82 2137.19 1909.7 2178.66 1835.11C2176.73 1851.9 2174.76 1870.81 2172.94 1890.68C2168.62 1937.76 2172.94 2039.48 2175.26 2068.86C2176.72 2087.33 2201.81 2083.46 2204.15 2068.81C2204.55 2066.33 2206.16 2057.62 2208.57 2044.63C2220.4 1980.92 2251.35 1814.16 2251.41 1773.33C2251.43 1756.91 2219.34 1742.15 2200.21 1753.63C2187.08 1739.61 2162.21 1731.53 2147.93 1754.69C2138.84 1769.42 2117.27 1811.22 2094.26 1860.03Z",
    fill: "#DCAE92"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2044.51 1968.17L2136.29 1750.69C2158.28 1715.31 2219.93 1757.89 2212.44 1778.41C2195.41 1824.99 2108.83 1975.81 2103.76 1989.69L2044.51 1968.17Z",
    fill: "#191847"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2046.28 1993.86C2044.67 1991.67 2041.56 1991.15 2039.48 1992.9C2035.68 1996.09 2030.22 2001.01 2028.25 2004.42C2025.11 2009.86 2020.9 2021.35 2020.9 2021.35C2027.21 2024.99 2134.32 2086.85 2134.32 2086.85C2134.32 2086.85 2147.18 2074.78 2138.33 2068.12C2129.48 2061.45 2123.72 2056.87 2123.72 2056.87L2084.57 2002.92C2083.8 2001.86 2082.31 2001.65 2081.27 2002.44L2073.14 2008.71C2073.14 2008.71 2061.95 2007.73 2056.43 2004.55C2053.08 2002.61 2048.98 1997.53 2046.28 1993.86Z",
    fill: "#E4E4E4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2175.82 2054.48C2173.33 2053.38 2170.38 2054.49 2169.45 2057.05C2167.76 2061.71 2165.49 2068.7 2165.49 2072.64C2165.49 2078.93 2167.58 2090.98 2167.58 2090.98C2174.87 2090.98 2298.55 2090.98 2298.55 2090.98C2298.55 2090.98 2303.66 2074.1 2292.66 2072.75C2281.66 2071.41 2274.38 2070.32 2274.38 2070.32L2213.51 2043.18C2212.32 2042.64 2210.92 2043.2 2210.42 2044.41L2206.51 2053.91C2206.51 2053.91 2196.32 2058.66 2189.96 2058.66C2186.08 2058.66 2179.99 2056.31 2175.82 2054.48Z",
    fill: "#E4E4E4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2257.84 1790.04C2257.84 1851.75 2228.54 1995.68 2228.53 2009.27L2165.49 2009.32C2165.49 2009.32 2179.33 1816.67 2175.31 1814.6C2171.28 1812.52 2010.32 1830.67 1962.04 1830.67C1892.43 1830.67 1863.63 1786.76 1861.3 1705.43H1999.2C2027.27 1708.43 2173.73 1737.98 2228.12 1748.13C2251.41 1752.48 2257.84 1773.05 2257.84 1790.04Z",
    fill: "#393F82"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2189.83 1600.73L2098.15 1613.24L2114.6 1654.33L2188.99 1624.83C2221.06 1627.99 2236.56 1627.23 2235.51 1622.54C2234.62 1618.59 2231.21 1617.4 2228.07 1616.3C2225.63 1615.44 2223.34 1614.64 2222.54 1612.64C2220.71 1608.07 2231.13 1598.59 2241.41 1590.03C2251.68 1581.46 2244.78 1579.88 2240.45 1580.01C2225.04 1583.62 2208.17 1590.53 2189.83 1600.73ZM1743.79 1825.99C1750.6 1812.18 1810.14 1634.47 1810.14 1634.47L1860.99 1634.66C1860.99 1634.66 1777.35 1822.91 1773.77 1831.79C1769.12 1843.32 1777.02 1860.08 1782.38 1871.45C1783.21 1873.2 1783.98 1874.83 1784.63 1876.29C1777.2 1879.62 1773.62 1875.6 1769.86 1871.36C1765.6 1866.57 1761.1 1861.5 1750.51 1866.43C1746.41 1868.33 1742.54 1870.58 1738.75 1872.79C1725.68 1880.38 1713.67 1887.37 1697.33 1877.28C1694.74 1875.69 1691.9 1869.67 1698.76 1864.97C1715.85 1853.25 1740.47 1832.74 1743.79 1825.99Z",
    fill: "#CCCCCC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1949.42 1473.16L1989.23 1475.82C1999.04 1564.54 2052.44 1620.59 2172.02 1601.61L2187.9 1715.87C2076.14 1730.32 1978.13 1685.57 1958.04 1564.39C1952.84 1533.02 1948.73 1500.38 1949.42 1473.16Z",
    fill: "#77D692"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1750.77 1802.97C1778.41 1655.87 1836.75 1542.06 1925.79 1461.55H1929.61H1929.74L1929.78 1461.59L1990.1 1475.41C1990.1 1547.88 2006.22 1602.03 2021.72 1654.1C2028.41 1676.58 2034.98 1698.67 2040.1 1721.68H1877.19C1874.89 1748.05 1873.48 1775.15 1872.75 1802.97H1750.77Z",
    fill: "#A8E5BA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1877.19 1721.68C1881.86 1668.01 1890.2 1617.37 1904 1569.78C1900.97 1620.68 1900.13 1683.82 1910.3 1721.68H1877.19Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1579.16 1164.26C1551.59 1164.26 1529.24 1186.62 1529.24 1214.19V1262.97C1529.24 1288.67 1548.65 1309.84 1573.61 1312.6C1573.62 1312.72 1573.62 1312.84 1573.63 1312.96H1640.97C1651.61 1302.55 1641.18 1236.24 1633.18 1206.74C1629.58 1182.7 1608.85 1164.26 1583.81 1164.26H1579.16Z",
    fill: "#B58143"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1582.5 1276.31C1597.53 1285.38 1612.31 1289.76 1619.24 1287.97C1636.63 1283.48 1638.23 1219.85 1624.78 1194.76C1611.32 1169.68 1542.15 1158.74 1538.66 1208.45C1537.45 1225.7 1544.69 1241.09 1555.39 1253.66L1536.2 1343.1H1591.93L1582.5 1276.31Z",
    fill: "#DCAE92"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1531.28 1208.74C1532.9 1207.14 1534.47 1205.59 1536.02 1204.2L1535.95 1202.4C1535.95 1202.4 1553.44 1166.58 1580.33 1166.58C1607.19 1166.58 1615.69 1179.07 1622.91 1189.69L1622.93 1189.72C1619.15 1202.69 1607.77 1207.93 1594.89 1213.86C1589.35 1216.42 1583.53 1219.1 1577.92 1222.58C1575.73 1220.79 1572.93 1219.72 1569.87 1219.72C1562.82 1219.72 1557.1 1225.44 1557.1 1232.5C1557.1 1239.55 1562.82 1245.27 1569.87 1245.27C1570.07 1245.27 1570.26 1245.27 1570.46 1245.26C1573.02 1272.85 1571.99 1304.35 1564.34 1311.83H1497C1495.07 1278.24 1503.76 1268.65 1512.63 1258.86C1520.99 1249.65 1529.51 1240.25 1529.51 1210.48C1530.11 1209.9 1530.7 1209.31 1531.28 1208.74Z",
    fill: "#B58143"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1517.63 1535.88L1605.01 1821.61L1647.34 2064.61H1680.53L1635.8 1535.88H1517.63Z",
    fill: "#DCAE92"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1517.63 1535.88L1605.01 1821.61L1647.34 2064.61H1680.53L1635.8 1535.88H1517.63Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1486.37 1535.88C1492.3 1692.76 1485.32 1773.68 1483.99 1787.94C1482.66 1802.19 1464.47 1894.61 1421.41 2069.4L1456.77 2057.25C1524.83 1896.95 1548.02 1813.63 1555.83 1792.58C1563.63 1771.53 1584.36 1685.96 1618.02 1535.88H1486.37Z",
    fill: "#DCAE92"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.11 2054.48C1425.62 2053.38 1422.66 2054.49 1421.74 2057.05C1420.05 2061.71 1417.78 2068.7 1417.78 2072.64C1417.78 2078.93 1419.87 2090.98 1419.87 2090.98C1427.16 2090.98 1550.84 2090.98 1550.84 2090.98C1550.84 2090.98 1555.95 2074.1 1544.95 2072.75C1533.95 2071.41 1526.67 2070.32 1526.67 2070.32L1465.8 2043.18C1464.6 2042.64 1463.2 2043.2 1462.71 2044.41L1458.79 2053.91C1458.79 2053.91 1448.61 2058.66 1442.24 2058.66C1438.37 2058.66 1432.28 2056.31 1428.11 2054.48Z",
    fill: "#E4E4E4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1646.39 2054.48C1643.9 2053.38 1640.94 2054.49 1640.01 2057.05C1638.32 2061.71 1636.05 2068.7 1636.05 2072.64C1636.05 2078.93 1638.15 2090.98 1638.15 2090.98C1645.43 2090.98 1769.12 2090.98 1769.12 2090.98C1769.12 2090.98 1774.22 2074.1 1763.22 2072.75C1752.22 2071.41 1744.95 2070.32 1744.95 2070.32L1684.07 2043.18C1682.88 2042.64 1681.48 2043.2 1680.98 2044.41L1677.07 2053.91C1677.07 2053.91 1666.89 2058.66 1660.52 2058.66C1656.65 2058.66 1650.56 2056.31 1646.39 2054.48Z",
    fill: "#E4E4E4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1506.02 1535.88L1543.17 1681.45H1656.65L1639.73 1535.88H1506.02Z",
    fill: "#191847"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1485.12 1535.88C1466.78 1590.85 1478.15 1681.45 1478.15 1681.45H1593.95L1625.8 1535.88H1485.12Z",
    fill: "#393F82"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1815.4 1435.32L1731.26 1472.28L1758.13 1506.7L1821.14 1458.38C1852.62 1452.59 1867.22 1447.63 1864.93 1443.47C1863.01 1439.97 1859.43 1439.77 1856.14 1439.59C1853.57 1439.45 1851.17 1439.32 1849.86 1437.64C1846.87 1433.81 1854.25 1421.98 1861.73 1411.05C1869.21 1400.12 1862.2 1400.51 1858.1 1401.82C1844.37 1409.46 1830.14 1420.63 1815.4 1435.32ZM1438.68 1491.9L1391.09 1482.46C1358.82 1567.53 1339.58 1614.15 1333.38 1622.32C1328.82 1628.31 1300.75 1643.73 1281.75 1651.97C1274.12 1655.27 1275.76 1661.72 1278 1663.78C1292.11 1676.79 1305.22 1672.23 1319.5 1667.27C1323.64 1665.83 1327.87 1664.36 1332.25 1663.27C1343.59 1660.46 1347.04 1666.29 1350.3 1671.8C1353.19 1676.68 1355.92 1681.31 1363.86 1679.46C1363.5 1677.9 1363.05 1676.16 1362.57 1674.28C1359.48 1662.11 1354.92 1644.16 1361.69 1633.73C1365.16 1628.38 1390.82 1581.1 1438.68 1491.9Z",
    fill: "#DCAE92"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1568.01 1304.39L1588.08 1300.94C1631.82 1343.38 1649.67 1445.32 1678.81 1458.82C1706.37 1471.58 1745.43 1459.23 1791.87 1442.56L1806.08 1474.34C1763.9 1519.99 1674.02 1558.56 1637.59 1536.54C1579.34 1501.34 1565.89 1375.6 1568.01 1304.39Z",
    fill: "#77D692"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1480.47 1556.78C1480.47 1556.78 1601.24 1556.78 1658.14 1556.78C1666.26 1556.78 1664.73 1545.05 1663.55 1539.14C1650.01 1470.85 1597.14 1397.24 1597.14 1300.04L1545.89 1292C1503.5 1360.19 1488.84 1444.14 1480.47 1556.78Z",
    fill: "#C7D1D9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1543.17 1292H1542.59C1427.64 1362.85 1358.17 1472.68 1334.18 1621.48L1371.42 1628.78C1396.09 1600.03 1426.54 1552.99 1462.75 1487.64C1451.64 1527 1443.53 1567.38 1441 1605.55H1600.93C1631.89 1527.29 1562.88 1292 1562.88 1292H1551.83H1543.17Z",
    fill: "#A8E5BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodap);
export default __webpack_public_path__ + "static/media/codap.6c56831385637902f54f2da0a5bf0cf9.svg";
export { ForwardRef as ReactComponent };